import { Injectable, Output, EventEmitter } from '@angular/core';
import { MenuModel } from 'gast-portal-ng/lib/menu-list/model/menu-model';
import { UrlService } from './common/url.service';
import { TranslateService } from '@ngx-translate/core';

/**
 * Service for Header functionality
 */
@Injectable()
export class HeaderService {
    readonly duoUrl = 'https://www.deutsch-uni.com/';
    @Output() showHeaderChanged: EventEmitter<Boolean> = new EventEmitter();
    @Output() showLoginChanged: EventEmitter<Boolean> = new EventEmitter();

    constructor(
        private urlService: UrlService,
        private translateService: TranslateService,
    ) { }

    public showHeader(showHeader: Boolean): void {
        return this.showHeaderChanged.emit(showHeader);
    }

    public showLogin(showLogin: Boolean): void {
        return this.showLoginChanged.emit(showLogin);
    }

    // tslint:disable:max-line-length
    public generateMenu(): Array<MenuModel> {
        const menuList = new Array<MenuModel>();
        menuList.push({
            menuName: 'MENU_LINK.LEARN_WITH_DUO',
            href: `${this.duoUrl}${this.translateService.currentLang}/${this.translateService.instant('GAST-PORTAL-NG.DUO-URL.LEARNING_WITH_DUO')}/`,
            isActive: false, useTranslation: true
        } as MenuModel);
        menuList.push({
            menuName: 'MENU_LINK.GERMAN_COURSE',
            href: `${this.duoUrl}${this.translateService.currentLang}/${this.translateService.instant('GAST-PORTAL-NG.DUO-URL.GERMAN_COURSE')}/`
            , isActive: true, useTranslation: true
        } as MenuModel);
        menuList.push({
            menuName: 'MENU_LINK.INSTITUTIONS',
            href: `${this.duoUrl}${this.translateService.currentLang}/${this.translateService.instant('GAST-PORTAL-NG.DUO-URL.INSTITUTIONS')}/`
            , isActive: false, useTranslation: true
        } as MenuModel);
        menuList.push({
            menuName: 'MENU_LINK.ABOUT_DUO',
            href: `${this.duoUrl}${this.translateService.currentLang}/${this.translateService.instant('GAST-PORTAL-NG.DUO-URL.ABOUT_DUO')}/`
            , isActive: false, useTranslation: true
        } as MenuModel);
        return menuList;
    }
}
